module.exports = __webpack_public_path__ + "static/img/10487967b2d453bc5a97f88bd4e6249d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon5.png
// module id = NR8N
// module chunks = 1